import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { PriceService } from './price.service';
import { PeriodicElement } from '../sales-realization/sales-realization.component';

@Component({
  selector: 'app-price-realization',
  templateUrl: './price-realization.component.html',
  styleUrls: ['./price-realization.component.scss']
})
export class PriceRealizationComponent implements OnInit {
  gutterSize: any = 5;
  displayedColumns: string[] = ['name', 'price'];
  dataSource: any;
  filterValue: any;
  selectedRowIndex: any = '';
  tableCloumnFirst: any = 'Price Spec';
  formDetails: any = {};
  selectedValues: any = {};
  total: any;
  qParam: any = {};
  initial: boolean = true;
  baseUrl = '/hhp/price/';
  totalPriceData: any = [];
  volumeImpactData: any = [];
  adjustmentTable: any = [];

  dataLoaded: boolean = false;
  showFilter: boolean = false;
  diamensionTitle = 'Total Price Impact';
  tableCloumnSecond = 'Price Impact';
  minSort: any;
  maxSort: any;
  filteredData: any;
  filter: any;
  search: boolean = false;
  minValue: number = 0;
  maxValue: number = 0;
  sorted: any[] = [];
  reset: number = 0;
  currentFilter: string = '';
  salesDataLoaded: boolean = false;
  totalPriceLoaded: boolean = false;
  volumeLoaded: boolean = false;
  suffix: number = 0;
  data: any = {};
  chartLoaded: boolean = false; 
  totalPricePercVal: any = {};

  constructor(
    private service: PriceService,
    private router: Router,
    public localStore: LocalStorageService
  ) { }


  selectedLevel;
  priceSpecSelected: boolean = false;


  ngOnInit(): void {
    let filters =
      this.localStore.getItem<any>('engineDropdown') != undefined
        ? this.localStore.getItem<any>('engineDropdown')
        : null;
    if (filters) {
      this.selectedValues = filters;
    } else {
      this.selectedValues['financial_reporting_region'] = ['All'];
      this.selectedValues['business_view'] = ['All'];
      this.selectedValues['sub_business_view'] = ['All'];
      this.selectedValues['lob_segment_2'] = ['All'];
      this.selectedValues['type'] = ['All'];
      this.selectedValues['revised_product_family_standard'] = ['All'];
      this.selectedValues['channel_new'] = ['All'];
      this.selectedValues['revised_customer_name'] = ['All'];
      this.selectedValues['wave_initiative'] = ['All'];
      this.selectedValues['classification'] = ['All'];
      this.selectedValues['product_flag'] = ['All'];
    }


    this.qParam = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    this.searchFilters();
    this.getTotalDimension();
    this.callToSingleForkJoin();
    this.resetFilter(event);


  }
  searchFilters() {

    let reg = {
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let businessView = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let subBusinessView = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let lobSegment = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let channelType = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };


    let engineModel = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let chan = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let customerName = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let waveInitiative = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let classifi = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      product_flag: this.selectedValues.product_flag,
    };

    let productFlag = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      classification: this.selectedValues.classification,
      wave_initiative: this.selectedValues.wave_initiative,

    };

    if (this.currentFilter != 'financial_reporting_region') {
      reg['current_dropdown'] =
        'financial_reporting_region';
      this.getDropdowndetails(reg);
    }

    if (this.currentFilter != 'business_view') {
      businessView['current_dropdown'] = 'business_view';
      this.getDropdowndetails(businessView);
    }

    if (this.currentFilter != 'sub_business_view') {
      subBusinessView['current_dropdown'] = 'sub_business_view';
      this.getDropdowndetails(subBusinessView);
    }

    if (this.currentFilter != 'lob_segment_2') {
      lobSegment['current_dropdown'] = 'lob_segment_2';
      this.getDropdowndetails(lobSegment);
    }


    if (this.currentFilter != 'type') {
      channelType['current_dropdown'] = 'type';
      this.getDropdowndetails(channelType);
    }

    if (this.currentFilter != 'channel_new') {
      chan['current_dropdown'] = 'channel_new';
      this.getDropdowndetails(chan);
    }

    if (this.currentFilter != 'revised_product_family_standard') {
      engineModel['current_dropdown'] = 'revised_product_family_standard';
      this.getDropdowndetails(engineModel);
    }

    if (this.currentFilter != 'revised_customer_name') {
      customerName['current_dropdown'] = 'revised_customer_name';
      this.getDropdowndetails(customerName);
    }
    if (this.currentFilter != 'wave_initiative') {
      waveInitiative['current_dropdown'] = 'wave_initiative';
      this.getDropdowndetails(waveInitiative);
    }
    if (this.currentFilter != 'classification') {
      classifi['current_dropdown'] = 'classification';
      this.getDropdowndetails(classifi);
    }
    if (this.currentFilter != 'product_flag') {
      productFlag['current_dropdown'] = 'product_flag';
      this.getDropdowndetails(productFlag);
    }
    this.getTotalPricePercentVal();

  }
  getDropdowndetails(type) {
    this.service
      .getHhpDropDownDetails(type, '/hhp/price/dropdown')
      .subscribe((results) => {
        let values: any[] = [];
        if (type.current_dropdown == 'financial_reporting_region') {
          values = results.financial_reporting_region;
        }
        if (type.current_dropdown == 'business_view')
          values = results.business_view;
        if (type.current_dropdown == 'sub_business_view')
          values = results.sub_business_view;
        if (type.current_dropdown == 'lob_segment_2')
          values = results.lob_segment_2;
        if (type.current_dropdown == 'type')
          values = results.type;
        if (type.current_dropdown == 'revised_product_family_standard')
          values = results.revised_product_family_standard;
        if (type.current_dropdown == 'channel_new') 
          values = results.channel_new;
        if (type.current_dropdown == 'revised_customer_name')
          values = results.revised_customer_name;
        if (type.current_dropdown == 'wave_initiative')
          values = results.wave_initiative;
        if (type.current_dropdown == 'classification')
          values = results.classification;
        if (type.current_dropdown == 'product_flag')
          values = results.product_flag;

        const resp = [...new Set(values)];
        if (type.current_dropdown == 'financial_reporting_region') {
          this.formDetails['financial_reporting_region'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'business_view') {
          this.formDetails['business_view'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'sub_business_view') {
          this.formDetails['sub_business_view'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'lob_segment_2') {
          this.formDetails['lob_segment_2'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
      
        if (type.current_dropdown == 'type') {
          this.formDetails['type'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'revised_product_family_standard') {
          this.formDetails['revised_product_family_standard'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
       
      
        if (type.current_dropdown == 'channel_new') {
          this.formDetails['channel_new'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'revised_customer_name') {
            this.formDetails['revised_customer_name'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'wave_initiative') {
          this.formDetails['wave_initiative'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'classification') {
          this.formDetails['classification'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'product_flag') {
          this.formDetails['product_flag'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        this.formDetails = { ...this.formDetails };
      });
  }

  callToSingleForkJoin() {
    let dropdown = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    this.localStore.createItem<any>('engineDropdown', dropdown);
    this.qParam = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    const salesBridgeObs = this.service.getPriceBridgeData(
      this.qParam,
      this.baseUrl + 'pricebridge/'
    );

    const totalPriceImpactObs = this.service.getTotalPriceImpact(
      this.qParam,
      this.baseUrl + 'totalpriceimpact/'
    );
    const totalVolumeImpactObs = this.service.getTotalVolumeImpact(
      this.qParam,
      this.baseUrl +  'salebreakdown/' 
    );

    forkJoin([
      salesBridgeObs,
      totalPriceImpactObs,
      totalVolumeImpactObs,
    ]).subscribe((item) => {
      (this.data = {
        priceRealization: item[0],
        priceImpact: item[1],
        volumeImpact: item[2],
      }),
        (this.data = { ...this.data });
      this.dataLoaded = true;
      this.chartLoaded = true;
    });
  }
  callToSingleForkJoinAlongRowClick(selectedRow: any) {
    let dropdown = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    this.localStore.createItem<any>('engineDropdown', dropdown);
    this.qParam = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    const salesBridgeObs = this.service.getPriceBridgeData(
      this.qParam,
      this.baseUrl + 'pricebridge/' + selectedRow
    );

    const totalPriceImpactObs = this.service.getTotalPriceImpact(
      this.qParam,
      this.baseUrl + 'totalpriceimpact/' + selectedRow
    );
    const totalVolumeImpactObs = this.service.getTotalVolumeImpact(
      this.qParam,
      this.baseUrl +  'salebreakdown/' + selectedRow
    );

    this.service.getPricePercentValuesAlongRowValues(this.qParam, selectedRow)
      .subscribe((resp) => {
        this.totalPricePercVal = resp;
      })

    forkJoin([
      salesBridgeObs,
      totalPriceImpactObs,
      totalVolumeImpactObs,
    ]).subscribe((item) => {
      (this.data = {
        priceRealization: item[0],
        priceImpact: item[1],
        volumeImpact: item[2],
      }),
        (this.data = { ...this.data });
      this.dataLoaded = true;
      this.chartLoaded = true;
    });
  }

  getOverallPurePrice(row) {
    if (this.selectedRowIndex !== row.name) {
      this.selectedRowIndex = row.name;
      this.initial = false;
      // this.callToSingleForkJoin();
      this.callToSingleForkJoinAlongRowClick(row.name);
    } else {
      this.selectedRowIndex = '';
      this.callToSingleForkJoin();
    }
  }

  searchSalesData(event) {
    this.currentFilter = event.type;
    this.dataLoaded = false;
    this.selectedValues[event.type] = event.value;
    this.qParam[event.type] = event.value;
    this.searchFilters();
    this.initial = true;
    this.callToSingleForkJoin();
    this.getTotalDimension();
  }
  searchDiamension(event) {
    this.selectedLevel = event.value;
    this.dataLoaded = false;

    this.initial = true;
    this.callToSingleForkJoin();
    this.getTotalDimension();
  }
  getTotalDimension() {
    this.search = false;
    this.showFilter = false;
    this.service
      .getTotalDimension(
        this.qParam,
        this.baseUrl + 'totalpriceimpact/pricespec'
        
      )
      .subscribe((res) => {
        const TABLE_DATA: PeriodicElement[] = [];
        this.total = res.total;
        Object.entries(res.data['price_spec']).forEach((data: any) => {
          TABLE_DATA.push({ name: data[0], price: data[1] });
        });
        this.dataSource = TABLE_DATA;
        this.minSort = this.dataSource.sort((a, b) => a.price - b.price);

        if (this.minSort && this.minSort.price) {
          this.minValue = this.minSort[0].price.toFixed();
        }

        this.maxSort = this.dataSource.sort((a, b) => b.price - a.price);

        if (this.maxSort && this.maxSort.price) {
          this.maxValue = this.maxSort[0].price.toFixed();
        }

        this.showFilter = true;
      });
  }
  onSearch(event) {
    this.search = true;
    if (event == 'All') {
      this.filteredData = this.dataSource;
    } else {
      this.filteredData = this.dataSource.filter((a) => a.name == event);
    }
  }
  rangeFilter(event) {
    this.filteredData = [];
    this.search = true;
    this.dataSource.forEach((item: any) => {
      if (item.price >= event.min && item.price <= event.max) {
        this.filteredData.push(item);
      }
    });
  }
  radioFilter(event) {
    if (event == 'top') {
      this.maxSort = this.minSort.sort((a, b) => b.price - a.price);
      this.filteredData = this.maxSort.slice(0, 5);
    } else if (event == 'bottom') {
      this.minSort = this.minSort.sort((a, b) => a.price - b.price);
      this.filteredData = this.minSort.slice(0, 5);
    }
    this.search = true;
  }

  chartClick(event) {

    let queryParams = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    if (
      event.name == 'Total Price Impact' &&
      this.data.priceRealization.total_price_impact !== 0
    ) {
      queryParams['header'] = 'Total Price Impact';
      this.router.navigate(['/price-deep-drive'], {
        queryParams: queryParams,
      });
    }


  }

  getTotalPricePercentVal() {
    this.service.getPricePercentValues(this.qParam)
      .subscribe((resp) => {
         this.totalPricePercVal = resp;
      })
  }

  resetFilter(event) {
    this.selectedValues['financial_reporting_region'] = ['All'];
    this.selectedValues['business_view'] = ['All'];
    this.selectedValues['sub_business_view'] = ['All'];
    this.selectedValues['lob_segment_2'] = ['All'];
    this.selectedValues['type'] = ['All'];
    this.selectedValues['revised_product_family_standard'] = ['All'];
    this.selectedValues['channel_new'] = ['All'];
    this.selectedValues['revised_customer_name'] = ['All'];
    this.selectedValues['wave_initiative'] = ['All'];
    this.selectedValues['classification'] = ['All'];
    this.selectedValues['product_flag'] = ['All'];

    this.qParam = this.selectedValues;
    this.currentFilter = '';
    this.searchFilters();
    this.callToSingleForkJoin();
    this.getTotalDimension();
    this.suffix = 0;
  }
  setSuffix(event) {
    this.suffix = event;
  }
}
